import useTranslation from 'common/hooks/useTranslation';
import React from 'react';

import DeleteCompanySection from './DeleteCompanySection';

const AdvancedSettingSection = ({ sectionTitle, description, children }) => (
  <div className='flex flex-col [&:not(:last-child)]:border-b border-gray-300 [&:not(:last-child)]:pb-6 mt-6'>
    {(sectionTitle || description) && (
      <div className='flex-1 flex flex-col gap-1 mb-4'>
        {sectionTitle && (
          <h3 className='text-lg font-semibold uppercase text-gray-700 '>
            {sectionTitle}
          </h3>
        )}
        {description && <p className='text-gray-500 text-sm'>{description}</p>}
      </div>
    )}
    {children}
  </div>
);

const AdvancedSettingsPanel = () => {
  const { t } = useTranslation('settings\\index');

  return (
    <div className='flex flex-col w-full'>
      <AdvancedSettingSection
        sectionTitle={t('advanced-tab-sections.deactivate-company.title')}
        description={t('advanced-tab-sections.deactivate-company.description')}
      >
        <DeleteCompanySection />
      </AdvancedSettingSection>
    </div>
  );
};

export default AdvancedSettingsPanel;
